import { Injectable, inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { lastValueFrom } from 'rxjs';
import { PartnersTunaService } from 'src/app/contexts/partners/partners-tuna.service';
import { UserService } from '../services/user.service';

@Injectable({ providedIn: 'root' })
export class RedirectGuard {

  constructor(
    private router: Router,
    private keycloak: KeycloakService,
    private partnersService: PartnersTunaService,
    private userService: UserService
  ) { }

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const partner = next.params.partner;
    const account = next.params.account;

    var user = await this.keycloak.loadUserProfile();
    var merchantUser = user['attributes'].partnerMerchantKeys ? user['attributes'].partnerMerchantKeys[0] : null;

    if (merchantUser) {
      return this.router.parseUrl(`${next.params.partner}/${next.params.account}/${merchantUser}/transactions`);
    }
    else {
      if (partner == 'tuna') {
        return this.router.parseUrl(`${partner}/${account}/partners`);
      } else if (!(this.userService.getUser().isSales || this.userService.getUser().isSupportMerchant)) {
        const result = await lastValueFrom(this.partnersService.getAccountInfo(partner, account));
        if (result?.code === 1) {
          if (!result.is_active) {
            return this.router.parseUrl(`${partner}/${account}/settings/company`);
          } else if (!result.has_activated_payment_services) {
            return this.router.parseUrl(`${partner}/${account}/services`);
          } else if (!result.has_published_flows) {
            return this.router.parseUrl(`${partner}/${account}/snapshot`);
          }
        }
      }

      return this.router.parseUrl(`${partner}/${account}/transactions`);
    }

  }

}


export const canActivate: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService = inject(RedirectGuard);

  return authService.canActivate(route, state);
};

export const canActivateRedirectChild: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => canActivate(route, state);
